// extracted by mini-css-extract-plugin
module.exports = {"tool":"_17oIQBi3b3en9URCaeTpoz"};